import { useEffect, useState } from "react";
import axios from "../api/axios";
import { useQueryClient } from "@tanstack/react-query";


export const usePayment = ({ authToken, navigate }: any) => {
    const queryClient = useQueryClient();
    const [paying, setPaying] = useState(false);

    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) setPaying(false);
        };
        window.addEventListener("pageshow", handlePageShow);
        return () => window.removeEventListener("pageshow", handlePageShow);
    }, []);

    const validateCheckout = async (payload: any) => {
        const res = await axios.post("/teleconsult/checkout-info", payload, {
        headers: { Authorization: `Bearer ${authToken}` },
        });
        return res.data;
    };

    const createPayment = async ({
        payload,
        checkoutInfo,
        onVoucherChanged,
    }: any) => {
        setPaying(true);

        try {
        const latest = await validateCheckout(payload);

        if (latest.discount !== checkoutInfo?.discount) {
            onVoucherChanged(latest);
            setPaying(false);
            return;
        }

        const res = await axios.post(
            "/teleconsult/create-and-pay",
            payload,
            {
            headers: { Authorization: `Bearer ${authToken}` },
            }
        );

        if (res.data.encToken && res.data.teleconsultId) {
            queryClient.invalidateQueries({ queryKey: ["checkout-info"] });
            navigate(
            `/connect-doctor/${res.data.teleconsultId}/${res.data.encToken}`
            );
            return;
        }

        if (res.data.paymentUrl) {
            queryClient.invalidateQueries({ queryKey: ["checkout-info"] });
            window.location.href = res.data.paymentUrl;
            return;
        }

        setPaying(false);
        } catch (err) {
        setPaying(false);
        throw err;
        }
    };

    return {
        paying,
        createPayment,
    };
};